import React, { useState, useEffect } from 'react';
import bgRightTop from '../../../assets/images/bg_right_top.png';
import bgLeftBottom from '../../../assets/images/bg_left_bottom.png';
import introVideoCover from '../../../assets/images/home/intro_video_cover.jpg';

const IntroVideo = () => {
    const [isPlaying, setIsPlaying] = useState(false);

    // Reset isPlaying state when page is refreshed
    useEffect(() => {
        setIsPlaying(false);
    }, []);

    const handlePlayClick = () => {
        console.log("Clicked", isPlaying);
        setIsPlaying(true);
    };

    return (
        <section className="py-20 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
            {/* Background Images */}
            <div className="absolute top-0 right-0 w-1/3 h-1/3">
                <img
                    src={bgRightTop}
                    alt="Background Decoration"
                    className="w-full h-full object-contain opacity-10"
                />
            </div>
            <div className="absolute bottom-0 left-0 w-1/3 h-1/3">
                <img
                    src={bgLeftBottom}
                    alt="Background Decoration"
                    className="w-full h-full object-contain opacity-10"
                />
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Welcome to <span className="text-primary">Nexgen Learning</span>
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Discover how we're revolutionizing education with cutting-edge technology and personalized learning experiences
                    </p>
                </div>

                <div className="relative max-w-4xl mx-auto">
                    {/* Video Container */}
                    <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl">
                        <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-purple-500/20 z-10"></div>

                        {!isPlaying ? (
                            <div className="relative w-full h-full cursor-pointer group">
                                <img
                                    src={introVideoCover}
                                    alt="Video Cover"
                                    className="w-full h-full object-cover"
                                />
                                {/* Play Button Overlay */}
                                <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-all duration-300">
                                    <div className="w-20 h-20 bg-white/90 rounded-full flex items-center justify-center group-hover:bg-white transition-all duration-300 cursor-pointer z-20" onClick={handlePlayClick}>
                                        <div className="w-0 h-0 border-t-[15px] border-t-transparent border-l-[25px] border-l-primary border-b-[15px] border-b-transparent ml-1 group-hover:scale-110 transition-transform duration-300"></div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <iframe
                                className="w-full h-full"
                                src="https://player.vimeo.com/video/1059133166?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&h=1d624b3c39#t="
                                title="Nexgen Learning Introduction"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        )}
                    </div>

                    {/* Video Features */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
                        <div className="text-center p-6 bg-white rounded-xl shadow-lg">
                            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold text-gray-900 mb-2">Innovative Learning</h3>
                            <p className="text-gray-600">Experience education reimagined with cutting-edge technology</p>
                        </div>

                        <div className="text-center p-6 bg-white rounded-xl shadow-lg">
                            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold text-gray-900 mb-2">Expert Instructors</h3>
                            <p className="text-gray-600">Learn from industry professionals and experienced educators</p>
                        </div>

                        <div className="text-center p-6 bg-white rounded-xl shadow-lg">
                            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold text-gray-900 mb-2">Interactive Experience</h3>
                            <p className="text-gray-600">Engage with dynamic content and real-time feedback</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default IntroVideo; 